/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const StoredCardValidityTypeEnum = {
    Expired: 'expired',
    UnsupportedCardType: 'unsupported_card_type',
    UnsupportedCurrencyForCardType: 'unsupported_currency_for_card_type'
};
/**
 * Check if a given object implements the StoredCardValidity interface.
 */
export function instanceOfStoredCardValidity(value) {
    return true;
}
export function StoredCardValidityFromJSON(json) {
    return StoredCardValidityFromJSONTyped(json, false);
}
export function StoredCardValidityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isValid': json['is_valid'] == null ? undefined : json['is_valid'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
export function StoredCardValidityToJSON(json) {
    return StoredCardValidityToJSONTyped(json, false);
}
export function StoredCardValidityToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'is_valid': value['isValid'],
        'type': value['type'],
    };
}
